import HistoriqueConstantes from '@/views/consultations/historique/view-historique/historique-constantes'
import HistoriqueMotifConsultation from '@/views/consultations/historique/view-historique/historique-motif-consultation'
import HistoriqueAnamneses from '@/views/consultations/historique/view-historique/historique-anamneses'
import HistoriqueExamenClinique from '@/views/consultations/historique/view-historique/historique-examen-clinique'
import HistoriqueHypotheseDiagnostique from '@/views/consultations/historique/view-historique/historique-hypothese-diagnostique'
import HistoriqueDiagnostic from '@/views/consultations/historique/view-historique/historique-diagnostic'
import HistoriqueAnalyseBiologique from '@/views/consultations/historique/view-historique/historique-analyse-biologique'
import HistoriqueImagerieMedicale from '@/views/consultations/historique/view-historique/historique-imagerie-medicale'
import HistoriqueOrdonnance from '@/views/consultations/historique/view-historique/historique-ordonnance'
import HistoriqueInfoComplementaire from '@/views/consultations/historique/view-historique/historique-info-complementaire'
import HistoriqueProtocoleSoins from '@/views/consultations/historique/view-historique/historique-protocole-soins'
import HistoriqueTraitementProtocole from '@/views/consultations/historique/view-historique/historique-traitement'
import HistoriqueSectionContents from '@/views/consultations/historique/view-historique/historique-section-contents'
import HistoriqueOrdonnaceLunettes from '@/views/consultations/historique/view-historique/historique-ordonnance-lunettes'
import HistoriqueAcuiteVisuelle from '@/views/consultations/historique/view-historique/historique-acuite-visuelle'
import HistoriqueGrossesse from '@/views/consultations/historique/view-historique/historique-grossesse'
import HistoriqueExamenFE from '@/views/consultations/historique/view-historique/historique-examen-fe'

export default {
    name: 'print-components',
    components: {
        HistoriqueConstantes, HistoriqueMotifConsultation, HistoriqueAnamneses,
        HistoriqueExamenClinique, HistoriqueHypotheseDiagnostique,
        HistoriqueDiagnostic, HistoriqueAnalyseBiologique, HistoriqueImagerieMedicale,
        HistoriqueOrdonnance, HistoriqueInfoComplementaire, HistoriqueProtocoleSoins,
        HistoriqueTraitementProtocole, HistoriqueSectionContents, HistoriqueOrdonnaceLunettes,
        HistoriqueAcuiteVisuelle, HistoriqueGrossesse, HistoriqueExamenFE,
    },
    props: {
        patient: {
            type: Object,
            default: () => {}
        },
    },

    data() {
        return {
            can_print: false,
            can_print_certif_medical: false
        }
    },

    watch: {
        can_print_ordl() {
            if (this.can_print_ordl == true) {
                this.printOrdonnanceLunette()
            }
        },

        can_print_certif() {
            if (this.can_print_certif) {
                this.printCertificatMedical()
            }
        },

        can_print_historique() {
            if (this.can_print_historique == true) {
                this.printHistoriqueConsultation()
            }
        },

        can_print_interpretation_examen() {
            if (this.can_print_interpretation_examen == true) {
                this.printInterpretationExamen()
            }
        },

        can_print_soins_ordonnance() {
            if (this.can_print_soins_ordonnance == true) {
                this.printSoinsOrdonnance()
            }
        },

        can_print_analyse() {
            if (this.can_print_analyse == true) {
                this.printAnalyse()
            }  
        },

        can_print_examen() {
            if (this.can_print_examen == true) {
                this.printExamen()
            }  
        },

        can_print_ordonnance() {
            if (this.can_print_ordonnance == true) {
                this.printOrdonnance()
            }  
        },

        can_print_comment() {
            if (this.can_print_comment == true) {
                this.printComment()
            }  
        }
    },

    computed: {
        ordonnance_lunettes_to_print() {
            return this.$store.getters['ordonnance_lunettes_to_print']
        },

        can_print_ordl() {
            return this.$store.getters['can_print_ordl']
        }, 
        
        certif_to_print() {
            return this.$store.getters['certif_to_print']
        },

        can_print_certif() {
            return this.$store.getters['can_print_certif']
        }, 

        historique_to_print() {
            return this.$store.getters['historique_to_print']
        },

        can_print_historique() {
            return this.$store.getters['can_print_historique']
        },

        can_print_interpretation_examen() {
            return this.$store.getters['can_print_interpretation_examen']
        },

        interpretation_examen_to_print() {
            return this.$store.getters['interpretation_examen_to_print']
        },

        can_print_soins_ordonnance() {
            return this.$store.getters['can_print_soins_ordonnance']
        },

        soins_ordonnance_to_print() {
            return this.$store.getters['soins_ordonnance_to_print']
        },

        can_print_analyse() {
            return this.$store.getters['can_print_analyse']
        },

        analyse_to_print() {
            return this.$store.getters['analyse_to_print']
        },

        can_print_examen() {
            return this.$store.getters['can_print_examen']
        },

        examen_to_print() {
            return this.$store.getters['examen_to_print']
        },

        can_print_ordonnance() {
            return this.$store.getters['can_print_ordonnance']
        },

        ordonnance_to_print() {
            return this.$store.getters['ordonnance_to_print']
        },

        can_print_comment() {
            return this.$store.getters['can_print_comment']
        },

        comment_to_print() {
            return this.$store.getters['comment_to_print']
        }
    },

    mounted() {
        this.$store.commit("SET_CAN_PRINT_ORDL", false)
        this.$store.commit("SET_ORDONNACE_LUNETTES_TO_PRINT", {})

        this.$store.commit("SET_CAN_PRINT_CERTIF", false)
        this.$store.commit("SET_CERTIF_TO_PRINT", {})

        this.$store.commit("SET_CAN_PRINT_HISTORIQUE", false)
        this.$store.commit("SET_HISTORIQUE_TO_PRINT", {})

        this.$store.commit("SET_CAN_PRINT_SOINS_ORDONNANCE", false)
        this.$store.commit("SET_SOINS_ORDONNANCE_TO_PRINT", {})

        this.$store.commit("SET_CAN_PRINT_ANALYSE", false)
        this.$store.commit("SET_ANALYSE_TO_PRINT", {})

        this.$store.commit("SET_CAN_PRINT_EXAMEN", false)
        this.$store.commit("SET_EXAMEN_TO_PRINT", {})

        this.$store.commit("SET_CAN_PRINT_ORDONNANCE", false)
        this.$store.commit("SET_ORDONNANCE_TO_PRINT", {})

        this.$store.commit("SET_CAN_PRINT_COMMENT", false)
        this.$store.commit("SET_COMMENT_TO_PRINT", {})
    },

    methods: {
        printOrdonnanceLunette() {
            this.can_print = true
            
            setTimeout(() => {
                window.print()

                this.can_print = false
                this.$store.commit("SET_CAN_PRINT_ORDL", false)
                this.$store.commit("SET_ORDONNACE_LUNETTES_TO_PRINT", {})
            }, 1500);
        },

        printCertificatMedical() {
            this.can_print_certif_medical = true
            
            setTimeout(() => {
                window.print()

                this.can_print_certif_medical = false
                this.$store.commit("SET_CAN_PRINT_CERTIF", false)
                this.$store.commit("SET_CERTIF_TO_PRINT", {})
            }, 1500);
        },

        printHistoriqueConsultation() {
            setTimeout(() => {
                window.print()

                // this.can_print_historique = false
                this.$store.commit("SET_CAN_PRINT_HISTORIQUE", false)
                this.$store.commit("SET_HISTORIQUE_TO_PRINT", {})
            }, 1500);
        },

        printInterpretationExamen() {
            setTimeout(() => {
                window.print()

                this.$store.commit("SET_CAN_PRINT_INTERPRETATION_EXAMEN", false)
                this.$store.commit("SET_INTERPRETATION_EXAMEN_TO_PRINT", {})
            }, 1500);
        },

        printSoinsOrdonnance() {
            setTimeout(() => {
                window.print()
                this.$store.commit("SET_CAN_PRINT_SOINS_ORDONNANCE", false)
                this.$store.commit("SET_SOINS_ORDONNANCE_TO_PRINT", {})
            }, 1000);
        },

        printAnalyse() {
            setTimeout(() => {
                window.print()
                this.$store.commit("SET_CAN_PRINT_ANALYSE", false)
                this.$store.commit("SET_ANALYSE_TO_PRINT", {})
            }, 1000);
        },

        printExamen() {
            setTimeout(() => {
                window.print()
                this.$store.commit("SET_CAN_PRINT_EXAMEN", false)
                this.$store.commit("SET_EXAMEN_TO_PRINT", {})
            }, 1000);
        },

        printOrdonnance() {
            setTimeout(() => {
                window.print()
                this.$store.commit("SET_CAN_PRINT_ORDONNANCE", false)
                this.$store.commit("SET_ORDONNANCE_TO_PRINT", {})
            }, 1000);
        },

        printComment() {
            setTimeout(() => {
                window.print()
                this.$store.commit("SET_CAN_PRINT_COMMENT", false)
                this.$store.commit("SET_COMMENT_TO_PRINT", {})
            }, 1000);
        }
    }
}